import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EnsureFormNotDirtyGuard implements CanDeactivate<unknown> {
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const currentComponent = component as any;

    // Allow user to leave by default if no form in current route.
    if (!currentComponent.form) {
      return true;
    }

    // Allow user to leave if form is not dirty
    if (!currentComponent.form.dirty) {
      return true;
    }

    // Do not allow user to leave if form is dirty
    // alert('There are unsaved changes, please save before you leave!');
    // return false;

    // TBC: If form is dirty, save form, user can go to next page
    return new Promise<boolean>((resolve, reject) => {
      currentComponent.model.onSaveAsDraft().then(() => {
        resolve(true);
      });
    });
  }
}
